import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { WagmiProvider, createConfig, http } from "wagmi";
import { injected } from "wagmi/connectors";
import { createClient } from "viem";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

const kaia = {
  id: 1001,
  name: "Kaia Testnet",
  network: "kairos",
  nativeCurrency: {
    name: "Kaia",
    symbol: "KAIA",
    decimals: 18,
  },
  rpcUrls: {
    default: { http: ["https://public-en-kairos.node.kaia.io"] },
    public: { http: ["https://public-en-kairos.node.kaia.io"] },
  },
};

const config = createConfig({
  chains: [kaia],
  connectors: [injected()],
  client({ chain }) {
    return createClient({
      chain,
      transport: http(),
    });
  },
});

const queryClient = new QueryClient();

ReactDOM.createRoot(document.getElementById("root")).render(
  <WagmiProvider config={config}>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </WagmiProvider>
);
